import { DateList } from './calendar';


class Tag {
  constructor(data) {
    this.name = data.name;
    this.slug = data.slug;
    this.isPrimary = data.is_primary;
    this.isListingDisplay = data.is_listing_display;
  }
}

class TagList {
  constructor(data) {
    this.tags = data.map(tag => new Tag(tag));
  }

  get slugs() {
    return this.tags.map(tag => tag.slug);
  }

  get displayTags() {
    return this.tags.filter(tag => tag.isListingDisplay === true);
  }
}


export default class Event {
  isShortlisted = false;

  constructor(data) {
    this.data = data;
    this.id = data.id;
    this.title = data.title;
    this.displayTitle = data.display_title_parsed;
    this.tagline = data.tagline;
    this.isShortlisted = data.is_shortlisted;
    this.isSellingFast = data.is_selling_fast;
    this.hasStatus = data.has_status;
    this.eventStatus = data.display_status;
    this.statusColor = data.status_color;
    this.isSoldOut = data.is_sold_out;
    this.canShortlist = data.can_shortlist;
    this.pageImageThumbnail = data.page_image_thumbnail;
    this.pageIntroText = data.page_intro_text_parsed;
    this.pageVideo = data.page_video;
    this.url = data.url;
    this.collections = data.collections;
    this.curatedCollections = data.curated_collections;
    this.tags = new TagList(data.tags);
    this.dates = new DateList(data.date_ranges);
  }

  get previewImage() {
    if (this.pageImageThumbnail) {
      return this.pageImageThumbnail;
    }
    return {
      'url': 'http://placekitten.com/600/688',
    };
  }

  get hasPreviewVideo() {
    return !!this.pageVideo;
  }

  get hasPageIntroText() {
    return !!this.pageIntroText;
  }

  get previewVideo() {
    return this.pageVideo;
  }

  get tagSlugs() {
    return this.tags.slugs;
  }

  get collectionSlugs() {
    return this.collections.map(collection => collection.slug);
  }

  get curatedCollectionSlugs() {
    return this.curatedCollections.map(collection => collection.slug);
  }
}
